<template>
  <div class="categories-tree">
    <div :style="indent" class="checkbox-container__shop">
      <input type="checkbox" :id="`${item.name}`" :checked="isChecked" @click="setCategory"/>
      <label :for="`${item.name}`">{{ item.name }}</label>
    </div>
    <categories
      v-for="node in nodes"
      :key="node.id"
      :nodes="node.children"
      :item="node"
      :depth="depth + 1"
      :parent-id="item.id"
    >
    </categories>
  </div>
</template>

<script>
import {mapGetters} from "vuex";
// import * as AppConfig from '@/config/AppConfig'

export default {
  name: "categories",
  props: {
    item: {
      type: Object,
      required: true
    },
    nodes: {
      type: Array,
      required: true
    },
    depth: {
      type: Number,
      required: true
    },
    parentId: {
      type: Number,
      // required: true
    },
    // isParentChecked: {
    //   type: Boolean,
    //   default: false
    // }
  },
  // data() {
  //   return {
  //     shopColor: AppConfig.SHOP_COLOR,
  //     isChecked: false,
  //   }
  // },
  watch: {
    isParentChecked: {
      handler: function () {
        // this.isChecked = this.isParentChecked
        // console.log('isParentChecked watcher', this.item.name, this.isParentChecked)
        if (this.isParentChecked) {
          this.$store.dispatch('setCategory', this.item.id)
        } else {
          this.$store.dispatch('removeCategory', this.item.id)
        }
      },
    },
    // isChecked: {
    //   handler: function () {
    //     this.$store.dispatch('setCategory', this.item.id)
    //   }
    // }
  },
  computed: {
    ...mapGetters(['getSelectedCategories']),
    indent() {
      return { 'margin-left': `${this.depth * 15}px` }
    },
    isChecked() {
      return this.getSelectedCategories.includes(this.item.id)
    },
    isParentChecked() {
      // console.log(this.item.name, this.getSelectedCategories.includes(this.parentId))
      return this.getSelectedCategories.includes(this.parentId)
    },
    // cssProps() {
    //   return {
    //     '--shop-color': this.shopColor,
    //   }
    // }
  },
  methods: {
    setCategory() {
      console.log(this.item)
      this.$store.dispatch('setCategory', this.item.id)
    }
  }
}
</script>

<style>
.checkbox-container__shop label{
  margin-bottom: 0;
  cursor: pointer;
  display: flex;
  align-items: center
}

.checkbox-container__shop input[type="checkbox"] {
  cursor: pointer;
  display: none;
}

.checkbox-container__shop input[type="checkbox"]:checked + label::before {
  content: '\002714';
  background-color: var(--shop-color);
  color: #fff;
  display: flex;
  justify-content: center;
  align-items: center;
}

.checkbox-container__shop label::before {
  content: '';
  width: 1em;
  height: 1em;
  border: .05em solid rgb(181,181,181);
  border-radius: .15em;
  margin-right: .5em;
}

.checkbox-container__shop label:hover::before {
  background-color: var(--shop-color);
}
</style>



// WEBPACK FOOTER //
// src/components/Categories.vue